import SignUp1Container from "../../../components/pages/other/SignUp1";

const SignUp1 = () => {
  return <SignUp1Container />;
};

export default SignUp1;
